/** Spanish names of Pokémon TCG rarities (as printed on Spanish cards); unknown ones stay as in the catalog. */
const RARITY_ES: Record<string, string> = {
  common: "Común",
  uncommon: "Infrecuente",
  rare: "Rara",
  "holo rare": "Rara holo",
  "holo rare v": "Rara holo V",
  "holo rare vmax": "Rara holo VMAX",
  "holo rare vstar": "Rara holo VSTAR",
  "rare holo lv.x": "Rara holo LV.X",
  "rare prime": "Rara PRIME",
  "shiny rare v": "Rara shiny V",
  "shiny rare vmax": "Rara shiny VMAX",
  legend: "LEYENDA",
  "rare holo": "Rara holo",
  "double rare": "Rara doble",
  "ultra rare": "Ultra rara",
  "illustration rare": "Rara ilustración",
  "special illustration rare": "Rara ilustración especial",
  "hyper rare": "Hiper rara",
  "secret rare": "Rara secreta",
  "shiny rare": "Rara shiny",
  "shiny ultra rare": "Ultra rara shiny",
  "ace spec rare": "Rara AS TÁCTICO",
  "radiant rare": "Rara radiante",
  "amazing rare": "Rara asombrosa",
  "prism rare": "Rara prisma",
  "mega hyper rare": "Mega hiper rara",
  "black white rare": "Rara blanca y negra",
  promo: "Promocional",
  "classic collection": "Colección clásica",
  "shiny holo rare": "Rara holo shiny",
  "rainbow rare": "Rara arcoíris",
  "rare break": "Rara BREAK",
  "rare ace": "Rara AS",
  "futuristic rare": "Rara futurista",
  "mega attack rare": "Rara ataque mega",
  "code card": "Carta de código",
};

/** Placeholders in the source catalog: better to show nothing. */
const HIDDEN = new Set(["none", "unconfirmed", ""]);

export function rarityLabel(rarity: string | null | undefined, locale: "es" | "en"): string | null {
  if (!rarity || HIDDEN.has(rarity.trim().toLowerCase())) return null;
  return locale === "es" ? (RARITY_ES[rarity.trim().toLowerCase()] ?? rarity) : rarity;
}
